import { createContext } from "react";
import { UseFormSetValue } from "react-hook-form";

import { CustomizeFormValues, defaultFormValues } from "./hooks/customizeFormUtils";
import { initial, State } from "./store";

export interface Actions {
	setValue: UseFormSetValue<CustomizeFormValues>;
	onChangeViewType: (val: boolean) => void;
	onChangeSlide: (val: number) => void;
	reset: () => void;
	showRestoreDialog: () => void;
	hideRestoreDialog: () => void;
}

export interface ContextType {
	values: CustomizeFormValues;
	state: State;
	actions: Actions;
}

const defaultContextValues: ContextType = {
	values: defaultFormValues,
	state: initial,
	actions: {
		setValue: () => {},
		onChangeViewType: () => {},
		onChangeSlide: () => {},
		reset: () => {},
		showRestoreDialog: () => {},
		hideRestoreDialog: () => {}
	}
};

export default createContext<ContextType>(defaultContextValues);
